





































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_variables from '@/mixins/axios/indicador_variables'
//@ts-ignore
import indicador_unidad_medidas from '@/mixins/axios/indicador_unidad_medidas'
//@ts-ignore
import indicador_fuentes_informacions from '@/mixins/axios/indicador_fuentes_informacions'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'
//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
            
            {
                tag:'secretaria',
                data:'secretaria',
                active:true
            },
             {
                tag:'departamento',
                data:'departamento',
                active:true
            },
           
            {
                tag:'abreviasion',
                data:'abreviasion',
                active:true
            },
            {
                tag:'descripcion',
                data:'descripcion',
                active:true
            },
             {
                tag:'unidad_medida',
                data:'unidad_medida',
                active:true
            },
             {
                tag:'fuente',
                data:'fuente',
                active:true
            },
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
             
            
           
        ],




        id:null as any,
        descripcion:null as any,

indicador_fuentes_informacions_id:0,
abreviasion:null as any,
      indicador_unidad_medidas_id:0,
      idsecretaria:0,
      iddepartamento:0,
     
            departamentos:[] as any,
     dependencias:[] as any,
         
              indicador_variablesdata:[] as any,
              indicador_unidad_medidas:[]as any,
              indicador_fuentes_informacions:[]as any,
      
    }
  },
     mixins: [indicador_variables,indicador_unidad_medidas,indicador_fuentes_informacions,departamentos,dependencias],
     validations: {
    
           abreviasion: {
      required,
    },
 
     
           descripcion: {
      required,
    },
 
           indicador_unidad_medidas_id: {
      required,
    },
 
           indicador_fuentes_informacions_id: {
      required,
    },
 
  },
  methods:{
       onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      onChangeUM(event){
//console.log(event.target.value)
this.getDataUnidad_Medida(event.target.value);

},
      onChangeF(event){
//console.log(event.target.value)

this.getDataFuentes(event.target.value);
},
       async getDataUnidad_Medida(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_UNIDAD_MEDIDAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_unidad_medidas=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

       async getDataFuentes(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_FUENTES_INFORMACION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_fuentes_informacions=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_VARIABLES(row).then(response => {

                    if (response != null) {

 this.indicador_variablesdata=this.indicador_variablesdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }    $("#ac_modal_departamentos").modal("hide");
 this.$root.$emit('loading', false);
                });
      },

     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.indicador_unidad_medidas_id=0;
                 this.abreviasion=null;
                  this.descripcion=null;
                  this.indicador_fuentes_informacions_id=0;
                   this.idsecretaria=0;
                 this.iddepartamento=0;

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_variables').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.indicador_unidad_medidas_id=row.indicador_unidad_medidas_id;
                 this.abreviasion=row.abreviasion;
                  this.descripcion=row.descripcion;
                  this.indicador_fuentes_informacions_id=row.indicador_fuentes_informacions_id;
                   this.idsecretaria=row.idsecretaria;
           this.iddepartamento=row.iddepartamento;

            
          
 $('#ac_modal_indicador_variables').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_VARIABLES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_variablesdata.push(response)

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Variables, refresque la pagina");

                    } $("#ac_modal_indicador_variables").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){

let data= await this.EDITAR_INDICADOR_VARIABLES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador Variable modificado exitosamente, refresque la pagina");
  this.indicador_variablesdata=this.indicador_variablesdata.filter(item => item.id !== dat.id);
 this.indicador_variablesdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Variables, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           indicador_unidad_medidas_id:this.indicador_unidad_medidas_id,
                 abreviasion:this.abreviasion,
                descripcion:this.descripcion,
                indicador_fuentes_informacions_id:this.indicador_fuentes_informacions_id,
            idmunicipio:this.$store.state.user.usuario.id_municipio,
   idsecretaria:this.idsecretaria,
                      iddepartamento:this.iddepartamento,
}
console.log(dat)
 this.$root.$emit('loading', true); 
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_VARIABLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_variablesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
    this.getData();
    this.getDataUnidad_Medida();
      this.getDataFuentes();
       this.getDataSecretarias();
      //alert('10')
  }
})
export default class Home extends Vue {}

